import DataGrid from 'components/DataGrid';
import LoadingScreen from 'components/LoadingScreen';
import { Suspense } from 'react';

import { useCADataConfig } from './CADataGrid.config';

const CADataGrid = () => {
  const { config, data, loading } = useCADataConfig();

  return (
    <Suspense fallback={<LoadingScreen />}>
      <DataGrid config={config} data={data} loading={loading} />
    </Suspense>
  );
};

export default CADataGrid;
